<ng-template #left>
    <shared-link [emphasis]="emphasis" (onClick)="handleResendClick($event)">Re-send email
    </shared-link>
</ng-template>

<ng-template #right>
    <shared-forms-submit (onClick)="handleReturnClick($event)" [loading]="loading$ | async" marginTop="none"
        width="normal">
        Return to sign in
    </shared-forms-submit>
</ng-template>

<shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
</shared-forms-offset-wrapper>